import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createBrowserHistory } from 'history';
import {
    Router,
    Route,
    Switch
} from 'react-router-dom';

import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import reducers from './reducers';
import {MuiThemeProvider, createMuiTheme, responsiveFontSizes} from '@material-ui/core/styles';
import './assets/scss/i4frontend.css';

import CustomTheme from "./common/CustomTheme";
import indexRoutes from './routes';
import AppBase from "./layouts/AppBase";
import store from './reducers/store';
export const hist = createBrowserHistory();


const theme = responsiveFontSizes(createMuiTheme({
    spacing: 2,
    ...CustomTheme.palette,
    ...CustomTheme.overrides
}));



//console.log(theme);

const App = () => (
  <Provider store={store}>
      <MuiThemeProvider theme={theme}>
          <CssBaseline/>
          <BrowserRouter>
              {/*<Router history={hist}>*/}
                  <Switch>
                        {/*console.log("app.js.render");*/}
                      {
                          indexRoutes.map((prop,key) => {
                              return (
                                  <Route
                                      path={prop.path}
                                      key={key}
                                      component={prop.component}
                                      {...prop.extra}
                                  />
                              );
                          })
                      }
                  </Switch>
              {/*</Router>*/}
          </BrowserRouter>
      </MuiThemeProvider>
  </Provider>
);


export default App;
